import HotelStrategyDetailBaseRoute from 'lumen/routes/hotel/strategy/detail-base';
import { TYPE_ID_MEALTYPE } from 'lumen/utils/constants/rate-strategy-constants';

export default class HotelStrategyMealtypeRoute extends HotelStrategyDetailBaseRoute {
  type = TYPE_ID_MEALTYPE;
}
